import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "mt-5 mb-3 flex items-center justify-between text-[14px]"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "ai-image",
  style: {
    "height": "100vh"
  }
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "segmented"
};
const _hoisted_6 = {
  class: "modal-switch-container"
};
const _hoisted_7 = {
  class: "flex items-center justify-center mt-3"
};
import { createReusableTemplate } from '@vueuse/core';
import Tag from './Tag.vue';
import { omit } from 'lodash-es';
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict';
import { AiWriteTypeEnum, WriteExample } from '@/views/aip/utils/constants';
import { ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Left',
  props: {
    isWriting: {
      type: Boolean
    }
  },
  emits: ["submit", "example", "reset"],
  setup(__props, {
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const emits = __emit;
    /** 点击示例的时候，将定义好的文章作为示例展示出来 **/
    const example = type => {
      formData.value = {
        ...initData,
        ...omit(WriteExample[type], ['data'])
      };
      emits('example', type);
    };
    /** 重置，将表单值作为初选值 **/
    const reset = () => {
      formData.value = {
        ...initData
      };
      emits('reset');
    };
    const selectedTab = ref(AiWriteTypeEnum.WRITING);
    const tabs = [{
      label: '撰写',
      value: AiWriteTypeEnum.WRITING
    }, {
      label: '回复',
      value: AiWriteTypeEnum.REPLY
    }];
    const [DefineTab, ReuseTab] = createReusableTemplate();
    /**
     * 可以在 template 里边定义可复用的组件，DefineLabel，ReuseLabel 是采用的解构赋值，都是 Vue 组件
     *
     * 直接通过组件的形式使用，<DefineLabel v-slot="{ label, hint, hintClick }"> 中间是需要复用的组件代码 <DefineLabel />，通过 <ReuseLabel /> 来使用定义的组件
     * DefineLabel 里边的 v-slot="{ label, hint, hintClick }"相当于是解构了组件的 prop，需要注意的是 boolean 类型，需要显式的赋值比如 <ReuseLabel :flag="true" />
     * 事件也得以 prop 形式传入，不能是 @event的形式，比如下面的 hintClick 需要<ReuseLabel :hintClick="() => { doSomething }"/>
     *
     * @see https://vueuse.org/createReusableTemplate
     */
    const [DefineLabel, ReuseLabel] = createReusableTemplate();
    const initData = {
      type: 1,
      prompt: '',
      originalContent: '',
      tone: 1,
      language: 1,
      length: 1,
      format: 1
    };
    const formData = ref({
      ...initData
    });
    /** 用来记录切换之前所填写的数据，切换的时候给赋值回来 **/
    const recordFormData = {};
    /** 切换tab **/
    const switchTab = value => {
      if (value !== selectedTab.value) {
        // 保存之前的久数据
        recordFormData[selectedTab.value] = formData.value;
        selectedTab.value = value;
        // 将之前的旧数据赋值回来
        formData.value = {
          ...initData,
          ...recordFormData[value]
        };
      }
    };
    /** 提交写作 */
    const submit = () => {
      if (selectedTab.value === 2 && !formData.value.originalContent) {
        message.warning('请输入原文');
        return;
      }
      if (!formData.value.prompt) {
        message.warning(`请输入${selectedTab.value === 1 ? '写作' : '回复'}内容`);
        return;
      }
      emits('submit', {
        /** 撰写的时候没有 originalContent 字段**/
        ...(selectedTab.value === 1 ? omit(formData.value, ['originalContent']) : formData.value),
        /** 使用选中 tab 值覆盖当前的 type 类型 **/
        type: selectedTab.value
      });
    };
    return (_ctx, _cache) => {
      const _component_el_segmented = _resolveComponent("el-segmented");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(DefineLabel), null, {
        default: _withCtx(({
          label,
          hint,
          hintClick
        }) => [_createElementVNode("h3", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(label), 1), hint ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "flex items-center text-[12px] text-[#846af7] cursor-pointer select-none",
          onClick: hintClick
        }, [_createVNode(Icon, {
          icon: "ep:question-filled"
        }), _createTextVNode(" " + _toDisplayString(hint), 1)], 8, _hoisted_2)) : _createCommentVNode("", true)])]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_segmented, {
        modelValue: selectedTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedTab.value = $event),
        options: tabs,
        onChange: switchTab
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [selectedTab.value === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_unref(ReuseLabel), {
        "hint-click": () => example('write'),
        hint: "示例",
        label: "写作内容"
      }, null, 8, ["hint-click"]), _createVNode(_component_el_input, {
        modelValue: formData.value.prompt,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.prompt = $event),
        maxlength: 500,
        rows: 5,
        placeholder: "请输入写作内容",
        showWordLimit: "",
        type: "textarea"
      }, null, 8, ["modelValue"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_unref(ReuseLabel), {
        "hint-click": () => example('reply'),
        hint: "示例",
        label: "原文"
      }, null, 8, ["hint-click"]), _createVNode(_component_el_input, {
        modelValue: formData.value.originalContent,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.originalContent = $event),
        maxlength: 500,
        rows: 5,
        placeholder: "请输入原文",
        showWordLimit: "",
        type: "textarea"
      }, null, 8, ["modelValue"]), _createVNode(_unref(ReuseLabel), {
        label: "回复内容"
      }), _createVNode(_component_el_input, {
        modelValue: formData.value.prompt,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.prompt = $event),
        maxlength: 500,
        rows: 5,
        placeholder: "请输入回复内容",
        showWordLimit: "",
        type: "textarea"
      }, null, 8, ["modelValue"])], 64)), _createVNode(_unref(ReuseLabel), {
        label: "长度"
      }), _createVNode(Tag, {
        modelValue: formData.value.length,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.length = $event),
        tags: _unref(getIntDictOptions)(_unref(DICT_TYPE).AI_WRITE_LENGTH)
      }, null, 8, ["modelValue", "tags"]), _createVNode(_unref(ReuseLabel), {
        label: "格式"
      }), _createVNode(Tag, {
        modelValue: formData.value.format,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.format = $event),
        tags: _unref(getIntDictOptions)(_unref(DICT_TYPE).AI_WRITE_FORMAT)
      }, null, 8, ["modelValue", "tags"]), _createVNode(_unref(ReuseLabel), {
        label: "语气"
      }), _createVNode(Tag, {
        modelValue: formData.value.tone,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.value.tone = $event),
        tags: _unref(getIntDictOptions)(_unref(DICT_TYPE).AI_WRITE_TONE)
      }, null, 8, ["modelValue", "tags"]), _createVNode(_unref(ReuseLabel), {
        label: "语言"
      }), _createVNode(Tag, {
        modelValue: formData.value.language,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.value.language = $event),
        tags: _unref(getIntDictOptions)(_unref(DICT_TYPE).AI_WRITE_LANGUAGE)
      }, null, 8, ["modelValue", "tags"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
        disabled: _ctx.isWriting,
        onClick: reset
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("重置")])),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        loading: _ctx.isWriting,
        color: "#846af7",
        onClick: submit
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("生成")])),
        _: 1
      }, 8, ["loading"])])])])])], 64);
    };
  }
});